<div
  [class.command-center-active]="showCommandCenter()"
  [class.hiding-command-center]="hidingCommandCenter()"
  [class.with-execution-plan]="hasExecutionPlan()"
  class="app-root-container"
>
  <div
    [class.cc-hidden]="!showCommandCenter()"
    class="command-center-content"
  >
    <!-- Command center header -->
    <div class="grid grid-rows-[auto_1fr] command-center-header command-center-transition gap-5">
      <div class="grid grid-cols-[auto_1fr_auto] items-center text-white dark">
        <div class="flex items-center gap-4 col-start-2 justify-self-center text-3xl">
          <i class="ph ph-sparkle text-yellow-500"></i>
          <span class="leading-[3.125rem] font-bold">AI Command Center</span>
        </div>

        <div class="flex items-center gap-2 justify-self-end">
          @if (hasActiveConversation()) {
            <button
              (click)="newSession()"
              class="flx-ds primary w-fit text-xs h-8"
              flxButton
              variant="text"
            >
              <span>New Session</span>
            </button>
          }
          <button
            (click)="resetCommandCenter()"
            class="flx-ds primary w-fit"
            icon="center"
            flxButton
            variant="text"
          >
            <i
              class="ph ph-arrows-in-simple"
              flxIcon
            ></i>
          </button>
        </div>
      </div>

      <flx-context-header />
    </div>

    <!-- Execution plan -->
    @if (hasExecutionPlan()) {
      <div
        class="execution-plan-wrapper command-center-transition col-start-1 col-span-2 row-span-2 row-start-1 border-neutral-600 border-r"
      >
        <flx-execution-plan />
      </div>
    }

    <!-- Chat -->
    <div class="chat-wrapper command-center-transition">
      <div class="chat h-full flex flex-col text-white border-neutral-600">
        <div class="flex items-center border-b border-neutral-600 py-6 px-4 flex-none">
          <span class="font-bold text-xl leading-8">Chat with Agent</span>
        </div>

        <flx-command-center-chat />
      </div>

      <!-- Documents -->
      <div
        [class.hiding-documents]="showDocuments() === false"
        class="documents-wrapper command-center-transition"
      >
        <flx-documents-list />
      </div>
    </div>
  </div>

  <!-- Main content -->
  <div class="main-content-wrapper">
    <div
      [class.pip-container]="showCommandCenter()"
      id="overlay-root"
      class="router-wrapper"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

@if (effectiveShowAiFab()) {
  <flx-ai-fab [boostZIndex]="runInstanceActive() && runInstancePanelOpen()" />
}
